import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UpgradeService } from '../services/upgrade.service';

export const upgradeResolver = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const upgradeService = inject(UpgradeService);
  let page = 1;
  if (route.queryParams['page']) {
    page = route.queryParams['page'];
  }
  return upgradeService.getAll$(page).pipe(
    map(list => list),
    catchError(error => {
      router.navigate(['/dashboard']);
      return of({ list: null, error: error });
    })
  );
};
